import api from 'api';
import React, { useEffect, useState } from 'react'
import Spinner from "components/Spinner/Spinner";
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const getActivityColor = (activity) => {
    if (!activity) return '#6c757d';
    if (activity.includes('Valid') && !activity.includes('Invalid')) return '#28a745';
    if (activity.includes('Invalid') || activity.includes('Failed')) return '#dc3545';
    if (activity.includes('Repeat')) return '#fd7e14';
    if (activity.includes('Login')) return '#362FD8';
    if (activity.includes('Points') || activity.includes('Redeemed')) return '#6f42c1';
    if (activity.includes('Password') || activity.includes('Brand')) return '#17a2b8';
    return '#6c757d';
};

const Index = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedLog, setSelectedLog] = useState(null);
    const history = useHistory();

    const getUserLogs = async () => {
        try {
            setLoading(true);
            const res = await api("get", `/logs/userlogs?page=1&pageSize=8`);
            setData(res?.userLogs || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUserLogs();
    }, []);

    return (
        <>
            {loading && <Spinner />}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '12px', color: '#999', fontFamily: 'Outfit' }}>Latest scan and account activity</span>
            </div>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', overflow: 'hidden' }}>
                {data?.length > 0 ? data.map((item) => {
                    const meta = item.metadata;
                    const isScan = item.emailType?.includes('Scan') || item.emailType?.includes('Valid');
                    const subtitle = isScan
                        ? [meta?.batchName, meta?.batchId ? `#${meta.batchId}` : '', meta?.location ? [meta.location.city, meta.location.region].filter(Boolean).join(', ') : ''].filter(Boolean).join(' · ')
                        : null;

                    return (
                        <div
                            key={item._id}
                            onClick={() => setSelectedLog(item)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '14px 20px',
                                borderBottom: '1px solid #f5f5f5',
                                gap: '12px',
                                cursor: 'pointer',
                                transition: 'background 0.15s',
                                fontFamily: 'Outfit',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fb'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ''; }}
                        >
                            <span style={{
                                fontSize: '11px', fontWeight: 600, padding: '3px 10px', borderRadius: '4px',
                                backgroundColor: getActivityColor(item.emailType), color: '#fff',
                                whiteSpace: 'nowrap', flexShrink: 0,
                            }}>
                                {item.emailType}
                            </span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: '13px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {meta?.code || (typeof item.description === 'object' ? JSON.stringify(item.description) : item.description)}
                                </div>
                                {subtitle && (
                                    <div style={{ fontSize: '11px', color: '#999', marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {subtitle}
                                    </div>
                                )}
                            </div>
                            <span style={{ fontSize: '12px', color: '#999', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                {moment(item.createdAt).fromNow()}
                            </span>
                        </div>
                    );
                }) : (
                    <div style={{ padding: '24px', textAlign: 'center', color: '#888', fontFamily: 'Outfit' }}>
                        No recent activity
                    </div>
                )}
            </div>

            {/* Detail modal — same as brand dashboard */}
            {selectedLog && (
                <div onClick={() => setSelectedLog(null)} style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <div onClick={(e) => e.stopPropagation()} style={{
                        backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
                        maxWidth: '480px', width: '90%', fontFamily: 'Outfit', maxHeight: '80vh', overflow: 'auto',
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{
                                fontSize: '12px', fontWeight: 600, padding: '4px 12px', borderRadius: '4px',
                                backgroundColor: getActivityColor(selectedLog.emailType), color: '#fff',
                            }}>
                                {selectedLog.emailType}
                            </span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{moment(selectedLog.createdAt).format('MMM DD, YYYY hh:mm A')}</span>
                        </div>
                        <p style={{ fontSize: '14px', color: '#333', marginBottom: '16px', lineHeight: '1.5' }}>{typeof selectedLog.description === 'object' ? JSON.stringify(selectedLog.description) : selectedLog.description}</p>
                        {selectedLog.email && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
                                <span style={{ fontWeight: 500, color: '#888' }}>User: </span>{selectedLog.email}
                            </div>
                        )}
                        {selectedLog.ip && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
                                <span style={{ fontWeight: 500, color: '#888' }}>IP: </span>{selectedLog.ip}
                            </div>
                        )}
                        {selectedLog.metadata && Object.keys(selectedLog.metadata).length > 0 && (
                            <div style={{ borderTop: '1px solid #eee', paddingTop: '12px' }}>
                                {Object.entries(selectedLog.metadata).map(([key, value]) => {
                                    if (value === null || value === undefined || value === '' || key === 'brandId') return null;
                                    const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
                                    const display = typeof value === 'object' ? Object.values(value).filter(Boolean).join(', ') : String(value);
                                    return (
                                        <div key={key} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '13px', borderBottom: '1px solid #f5f5f5' }}>
                                            <span style={{ color: '#888', fontWeight: 500 }}>{label}</span>
                                            <span style={{ color: '#333', textAlign: 'right', maxWidth: '60%', wordBreak: 'break-word' }}>{display}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        <button onClick={() => setSelectedLog(null)} style={{
                            marginTop: '16px', width: '100%', padding: '10px', backgroundColor: '#362FD8',
                            color: '#fff', border: 'none', borderRadius: '8px', fontFamily: 'Outfit',
                            fontWeight: 600, fontSize: '14px', cursor: 'pointer',
                        }}>Close</button>
                    </div>
                </div>
            )}
        </>
    )
}

export default Index
